module.exports = __webpack_public_path__ + "img/app-item-uploaded-dark.e38fb8f9.svg";